var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#381B76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3721 6.88783C12.5752 6.96483 12.5752 7.27049 12.3721 7.3475C11.5134 7.67313 10.02 8.29919 9.39402 8.92524C8.76634 9.55292 8.13866 10.9712 7.81374 11.7791C7.73439 11.9764 7.4384 11.9764 7.35905 11.7791C7.03413 10.9711 6.40645 9.55292 5.77886 8.92524C5.15281 8.29919 3.65938 7.67313 2.80069 7.3475C2.5977 7.27049 2.5977 6.96483 2.80069 6.88783C3.65938 6.56219 5.15281 5.93614 5.77886 5.31009C6.40492 4.68404 7.03088 3.19064 7.35652 2.3319C7.43352 2.12887 7.73918 2.12887 7.81618 2.3319C8.14191 3.19063 8.76797 4.68404 9.39402 5.31009C10.02 5.93614 11.5134 6.56219 12.3721 6.88783Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1831 11.3962C14.3836 11.4795 14.3836 11.7928 14.1831 11.8761C13.7665 12.0491 13.2545 12.2946 13.009 12.5399C12.7621 12.7869 12.5152 13.2785 12.342 13.6737C12.2566 13.8685 11.9539 13.8685 11.8685 13.6737C11.6953 13.2785 11.4484 12.7869 11.2014 12.5399C10.956 12.2946 10.444 12.0491 10.0274 11.8761C9.82687 11.7928 9.82687 11.4795 10.0274 11.3962C10.444 11.2232 10.956 10.9777 11.2014 10.7324C11.4469 10.4869 11.6923 9.97489 11.8653 9.55824C11.9486 9.35778 12.2619 9.35778 12.3452 9.55824C12.5182 9.97489 12.7636 10.4869 13.009 10.7324C13.2545 10.9777 13.7665 11.2232 14.1831 11.3962Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.5d3e703566e292c06b5612127d58f6ad.svg";
export { ForwardRef as ReactComponent };